import { useQuery } from '@tanstack/react-query'
import { fetchPhoneNumbers } from './phone-number-api'

export function usePhoneNumbers(whatsappBusinessAccountId?: string | null) {
    return useQuery({
        queryFn: () => fetchPhoneNumbers(whatsappBusinessAccountId!),
        queryKey: ['phone-numbers', whatsappBusinessAccountId],
        enabled: !!whatsappBusinessAccountId,
    })
}
